import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS,AiraloSettings} from '@chekin/core';
import {API} from '@chekin/api';

function useFetchEsimPackages({
  country,
  settings,
}: {
  country?: string;
  settings?: AiraloSettings;
}) {
  const result = useQuery({
    queryKey: [
      QUERY_CACHE_KEYS.esimPackages,
      country,
      settings?.vat,
      settings?.airalo_profit,
      settings?.currency,
    ],
    queryFn: () =>
      API.upselling.getEsimPackages(
        {
          manager_vat: settings?.vat,
          manager_profit: settings?.airalo_profit,
          currency: settings?.currency?.toUpperCase(),
        },
        `country=${country}`,
      ),
    enabled: Boolean(country),
  });

  return result;
}

export {useFetchEsimPackages};
